const LEXICON_ENTITY_SPECIAL_CHAR_ESCAPE_MAP: Record<string, string> = {
  '\n': `$mp-nl`,
  '\t': `$mp-tab`,
  '\r': `$mp-cr`,
};

export function getEscapedEntityName(entityName: string): string;
export function getEscapedEntityName(entityName?: string): string | undefined;
export function getEscapedEntityName(entityName?: string): string | undefined {
  if (!entityName) {
    return entityName;
  }
  let replacedName = entityName;
  Object.entries(LEXICON_ENTITY_SPECIAL_CHAR_ESCAPE_MAP).forEach(([char, escapeStr]) => {
    replacedName = replacedName.replace(new RegExp(`\\${char}`, `g`), escapeStr);
  });
  return replacedName;
}

export function getUnescapedEntityName(entityName: string): string;
export function getUnescapedEntityName(entityName?: string): string | undefined;
export function getUnescapedEntityName(entityName?: string): string | undefined {
  if (!entityName) {
    return entityName;
  }
  let replacedName = entityName;
  Object.entries(LEXICON_ENTITY_SPECIAL_CHAR_ESCAPE_MAP).forEach(([char, escapeStr]) => {
    replacedName = replacedName.replace(escapeStr, char);
  });
  return replacedName;
}
